import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Button, Divider } from '@mui/material';
import { orange } from '@mui/material/colors';
import PropertyIcons from '../PropertyIcons';

function RentSaleItem(props) {
  return (
    <Box>
        <Box sx={{
            display: 'flex',
            flexDirection: { xs: 'column-reverse', md: 'row' },
            marginTop: '2rem',
            marginBottom: '2rem'
        }}>
            <Box sx={{
                width: { xs: '100%', md: '50%' }
            }}>
                <Link
                    style={{textDecoration: 'none'}}
                >
                    <h2 style={{
                        fontSize: '1.4em',
                        fontWeight: 'bold',
                        color: 'black',
                        textTransform: 'capitalize'
                    }}>
                        {props.itemTitle}
                    </h2>
                </Link>
                <Typography 
                    variant='h3'
                    sx={{
                        fontSize: '1.3em',
                        textTransform: 'uppercase',
                        marginTop: '0.3rem'
                    }}
                >
                    {props.itemAddress}
                </Typography>
                <Typography 
                    variant='body1'
                    sx={{
                        marginY: '1rem'
                    }}
                >
                    {props.itemShortDescription}
                </Typography>
            </Box>
            <Box sx={{
                width: { xs: '100%', md: '50%' },
                marginBottom: { xs: '2rem', md: '0' }
            }}>
                <Link 
                    style={{
                        display: 'flex',
                        justifyContent: 'center'
                    }}
                >
                    <img 
                        src={props.itemImg} 
                        alt="project listing"
                        style={{
                            height: 'auto', 
                            maxWidth: '75%'
                        }}
                    />
                </Link>
            </Box>
        </Box>
        <Divider />       
    </Box>
  )
}

export default RentSaleItem;